import React, { useCallback } from "react";
import { Col } from "react-bootstrap";
import * as Styled from "./TicketCard.styled";
import AttachmentIcon from "../../../assets/images/icons/attachment.svg";
import MessageIcon from "../../../assets/images/icons/message.svg";
import { formatDate, TicketProps } from "../../../libs";


export const TicketCard: React.FC<TicketProps> = ({ ticket, onOpenTicket, isAdmin }) => {
    const handleOpenTicket = useCallback(() => {
        onOpenTicket(ticket);
    }, [onOpenTicket, ticket]);

    return (
        <Styled.Wrapper>
            {/* Ticket Header */}
            <Styled.HeaderRow>
                <Col xs="auto">
                    <Styled.TicketInfoWrapper>
                        <Styled.PriorityDot style={{ backgroundColor: ticket.priority.color }} />
                        <Styled.TicketId>{`Ticket #${ticket.ticketId}`}</Styled.TicketId>
                    </Styled.TicketInfoWrapper>
                </Col>
                <Col xs="auto">
                    <Styled.PriorityTag>{ticket.priority.name}</Styled.PriorityTag>
                </Col>
                <Col className="text-end">
                    <Styled.PostedAt>{formatDate(ticket.createdAt)}</Styled.PostedAt>
                </Col>
            </Styled.HeaderRow>

            {/* Ticket Title */}
            <Styled.TicketTitle>{ticket.title}</Styled.TicketTitle>

            {/* Ticket Description */}
            <Styled.TicketDescription>{ticket.message}</Styled.TicketDescription>

            {/* Bottom Section */}
            <Styled.FooterRow>
                <Col xs="auto">
                    <Styled.IconWrapper>
                        {/* Show client name only if isAdmin is true */}
                        {isAdmin && <Styled.ClientName>{ticket.user.name}</Styled.ClientName>}

                        {/* Attachment Icon and Count */}
                        <Styled.IconPair>
                            <Styled.IconImage src={AttachmentIcon} alt="Attachments" />
                            <span>{ticket.attachments.length}</span>
                        </Styled.IconPair>

                        {/* Message Icon and Replies Count */}
                        <Styled.MessageIconPair>
                            <Styled.IconImage src={MessageIcon} alt="Messages" />
                            <span>{ticket.repliesCount}</span>
                        </Styled.MessageIconPair>
                    </Styled.IconWrapper>
                </Col>
                <Col className="text-end">
                    <Styled.OpenTicketButton onClick={handleOpenTicket}>Open Ticket</Styled.OpenTicketButton>
                </Col>
            </Styled.FooterRow>
        </Styled.Wrapper>
    );
};
